// Pure parser for the "Days After Job Date" numeric input on Expiration Date
// fields in the Field Manager (see IdCardForm.jsx). Kept separate from
// IdCardForm so it can be unit-tested without pulling KonvaCanvas + friends
// into the jest environment. Public API:
//
//   parseDaysOffsetInput(raw) -> null | number | undefined
//     ''      -> null           clear the value; field renders blank per spec
//     '14'    -> 14
//     'foo'   -> undefined      NaN typo -> caller must skip the save
//     '-5'    -> undefined      negative -> would print date BEFORE job date
//                               (the server has no floor either)
//
// The negative-input case is easy to regress: `parseInt('-5', 10) === -5`
// (not NaN), and the `min="0"` attr on the underlying <input type="number">
// is only a UI hint -- browsers accept typed/pasted negatives.
export function parseDaysOffsetInput(raw) {
  if (raw === '') return null;

  const n = parseInt(raw, 10);
  if (Number.isNaN(n) || n < 0) return undefined;

  return n;
}
